var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "admin-tools-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64,16c0,-8.831 -7.169,-16 -16,-16l-32,0c-8.831,0 -16,7.169 -16,16l0,32c0,8.831 7.169,16 16,16l32,0c8.831,0 16,-7.169 16,-16l0,-32Z",
    style: {
      fill: "url(#admin-tools-icon-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shadow",
    d: "M27.577,16.028c-1.32,0.366 -2.575,0.891 -3.742,1.553c0.001,-0 -2.713,-2.714 -2.713,-2.714c-1.067,-1.067 -2.8,-1.067 -3.867,-0c0,-0 -2.388,2.388 -2.388,2.388c-1.067,1.067 -1.067,2.8 -0,3.867c-0,0 2.714,2.714 2.714,2.714c-0.662,1.166 -1.187,2.421 -1.553,3.741c0.001,-0 -4.294,-0 -4.294,-0c-1.509,-0 -2.734,1.225 -2.734,2.734l0,3.378c0,1.509 1.225,2.734 2.734,2.734c0,0 4.295,0 4.295,0c0.408,1.476 1.016,2.87 1.792,4.151c-0,-0.001 -2.954,2.953 -2.954,2.953c-1.067,1.067 -1.067,2.8 -0,3.867c-0,-0 2.388,2.388 2.388,2.388c1.067,1.067 2.8,1.067 3.867,0c0,0 3.133,-3.133 3.133,-3.133c1.046,0.555 2.159,1.001 3.322,1.323c-0,-0.001 -0,4.294 -0,4.294c-0,1.509 1.225,2.734 2.734,2.734l3.378,0c1.509,0 2.734,-1.225 2.734,-2.734c0,-0 0,-4.295 0,-4.295c1.32,-0.365 2.575,-0.89 3.742,-1.552c-0.001,0 3.362,3.363 3.362,3.363c1.067,1.067 2.8,1.067 3.867,0c-0,0 2.388,-2.388 2.388,-2.388c1.067,-1.067 1.067,-2.8 0,-3.867c0,0 -3.363,-3.363 -3.363,-3.363c0.662,-1.166 1.187,-2.421 1.553,-3.741c-0.001,0 4.294,0 4.294,0c1.509,0 2.734,-1.225 2.734,-2.734l-0,-3.378c-0,-1.509 -1.225,-2.734 -2.734,-2.734c-0,-0 -4.295,-0 -4.295,-0c-0.321,-1.163 -0.767,-2.276 -1.322,-3.322c0,0 3.133,-3.133 3.133,-3.133c1.067,-1.067 1.067,-2.8 0,-3.867c0,0 -2.388,-2.388 -2.388,-2.388c-1.067,-1.067 -2.8,-1.067 -3.867,-0c0,-0 -2.954,2.954 -2.954,2.954c-1.28,-0.776 -2.674,-1.384 -4.15,-1.793c0,0.001 0,-4.294 0,-4.294c0,-1.509 -1.225,-2.734 -2.734,-2.734l-3.378,-0c-1.509,-0 -2.734,1.225 -2.734,2.734l0,4.294Zm4.423,10.262c3.151,0 5.71,2.559 5.71,5.71c-0,3.151 -2.559,5.71 -5.71,5.71c-3.151,-0 -5.71,-2.559 -5.71,-5.71c0,-3.151 2.559,-5.71 5.71,-5.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-tools-icon-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64,64,-64,64,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#c3ccff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6cfff",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.60ddc312b7a8652b1b8096f4dfa3091e.svg";
export { ForwardRef as ReactComponent };